import React from "react";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import PortfolioDetailsBanner from "./PortfolioDetailsBanner";
import PortfolioDetailsPost from "./PortfolioDetailsPost";

const PortfolioDetails = () => {
  return (
    <>
      <Menu header_style_2={true} />
      <PortfolioDetailsBanner />
      <PortfolioDetailsPost />
      <FooterThree />
    </>
  );
};

export default PortfolioDetails;
